/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type NOTIFICATION_TYPE = "COMMENT_APPROVED" | "COMMENT_FEATURED" | "COMMENT_REJECTED" | "DSA_REPORT_DECISION_MADE" | "ILLEGAL_REJECTED" | "REPLY" | "REPLY_STAFF" | "UNKNOWN" | "%future added value";
export type NotificationCommentContainer_notification = {
    readonly type: NOTIFICATION_TYPE | null;
    readonly " $refType": "NotificationCommentContainer_notification";
};
export type NotificationCommentContainer_notification$data = NotificationCommentContainer_notification;
export type NotificationCommentContainer_notification$key = {
    readonly " $data"?: NotificationCommentContainer_notification$data;
    readonly " $fragmentRefs": FragmentRefs<"NotificationCommentContainer_notification">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "NotificationCommentContainer_notification",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
        }
    ],
    "type": "Notification",
    "abstractKey": null
} as any);
(node as any).hash = '9f851a2bcfbd2f5fce56ab6a7c85c2f6';
export default node;
